import React from 'react';
// Updated import path for components.css
import '../styles/components.css';

const renderArrayAsText = (input) => {
  if (Array.isArray(input)) {
    return input.map((item, index) => (
      <span key={index}>
        {item.trim()}
        <br />
      </span>
    ));
  }
  return input.split('\n').map((str, index) => (
    <span key={index}>
      {str.trim()}
      <br />
    </span>
  ));
};

const Resume = ({
  name,
  title,
  location,
  email,
  phone,
  summary,
  experience,
  skills,
  education,
  publications,
}) => {
  return (
    <div className="resume">
      <div className="resume-header">
        <h1>{name}</h1>
        <p>{title}</p>
        <p>{location} | {email} | {phone}</p>
      </div>
      <div className="resume-section">
        <h2 className="section-header">Summary</h2>
        <p className="resume-text">{renderArrayAsText(summary)}</p>
      </div>
      <div className="resume-section">
        <h2 className="section-header">Professional Experience</h2>
        <p className="resume-text">{renderArrayAsText(experience)}</p>
      </div>
      <div className="resume-two-column">
        <div className="column-left">
          <div className="resume-section">
            <h2 className="section-header">Skills</h2>
            <p className="resume-text">{renderArrayAsText(skills)}</p>
          </div>
          <div className="resume-section">
            <h2 className="section-header">Education</h2>
            <p className="resume-text">{renderArrayAsText(education)}</p>
          </div>
        </div>
        <div className="column-right">
          <div className="resume-section">
            <h2 className="section-header">Publications</h2>
            <p className="resume-text">{renderArrayAsText(publications)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
